import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const UpdateHostsService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'updateHosts',
      method: 'put',
      request: (id, body, t) => ({
        url: apiRoutes.hosts(id),
        body,
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateHostsFailed'),
            onSuccessMessage: t('updateHostsSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateHostsService;
